module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "welcome"
  }, [(_vm.isLoading) ? _c('div') : _c('div', [_c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("addToHomeScreen.install_app")) + "\n        ")])]), _vm._v(" "), _c('div', [(_vm.showiOSModal) ? _c('div', {
    staticClass: "content-container"
  }, [_c('iframe', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/TMX46ia6i_4",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })]) : (_vm.showAndroidManual) ? _c('div', {
    staticClass: "content-container"
  }, [_c('iframe', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/OPRrk5oXXCY",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })]) : (_vm.showAndroidAutomat) ? _c('div', {
    staticClass: "content-container"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showAndroidAutomat) ? _c('div', {
    staticClass: "fullBtn",
    on: {
      "click": _vm.addToHomeScreen
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("addToHomeScreen.add_to_homescreen")) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showiOSModal || _vm.showAndroidManual) ? _c('div', {
    staticClass: "fullBtn",
    on: {
      "click": _vm.confirmiOSAdded
    }
  }, [_c('button', [_vm._v(_vm._s(_vm.$t("addToHomeScreen.saw_video")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ignore-container"
  }, [_c('p', {
    staticClass: "ignore-button",
    on: {
      "click": _vm.ignoreHomeScreen
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("addToHomeScreen.dont_install")) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36827d5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddToHomeScreen/AddToHomeScreen.vue
// module id = 490
// module chunks = 16